/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingSubscription } from './BillingSubscription';
import {
    BillingSubscriptionFromJSON,
    BillingSubscriptionFromJSONTyped,
    BillingSubscriptionToJSON,
    BillingSubscriptionToJSONTyped,
} from './BillingSubscription';

/**
 * 
 * @export
 * @interface UpdateBillingSubscriptionResponse
 */
export interface UpdateBillingSubscriptionResponse {
    /**
     * 
     * @type {BillingSubscription}
     * @memberof UpdateBillingSubscriptionResponse
     */
    data: BillingSubscription;
}

/**
 * Check if a given object implements the UpdateBillingSubscriptionResponse interface.
 */
export function instanceOfUpdateBillingSubscriptionResponse(value: object): value is UpdateBillingSubscriptionResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateBillingSubscriptionResponseFromJSON(json: any): UpdateBillingSubscriptionResponse {
    return UpdateBillingSubscriptionResponseFromJSONTyped(json, false);
}

export function UpdateBillingSubscriptionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBillingSubscriptionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': BillingSubscriptionFromJSON(json['data']),
    };
}

  export function UpdateBillingSubscriptionResponseToJSON(json: any): UpdateBillingSubscriptionResponse {
      return UpdateBillingSubscriptionResponseToJSONTyped(json, false);
  }

  export function UpdateBillingSubscriptionResponseToJSONTyped(value?: UpdateBillingSubscriptionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BillingSubscriptionToJSON(value['data']),
    };
}

